import { AxiosResponse } from 'axios';
import { CatalogCategoriesDto } from '../../../types/dto/CatalogCategoriesDto';
import { CatalogCategory } from '../../../types/CatalogCategory';

const mapCatalogCategoriesDtoToCatalogCategory = ({ data }: AxiosResponse<CatalogCategoriesDto>): CatalogCategory[] => data.value
  .filter(({ Active }) => Active)
  .map(({ CategoryID, CategoryName }) => ({ id: CategoryID, name: CategoryName }));

export default mapCatalogCategoriesDtoToCatalogCategory;
